import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { 
  Home, 
  FileText, 
  Users, 
  Settings, 
  Plus, 
  Shield,
  Award
} from 'lucide-react'
import { useAuthStore } from '../../store/authStore'
import { getUserType } from '../../utils/userPermissions'

interface GovernmentNavProps {
  className?: string
}

export const GovernmentNav: React.FC<GovernmentNavProps> = ({ className = '' }) => {
  const { user } = useAuthStore()
  const location = useLocation()
  const userType = getUserType(user)

  const isActive = (path: string) => location.pathname === path

  // Government Agency Navigation Items
  const agencyNavItems = [
    {
      label: 'Dashboard',
      path: '/government',
      icon: Home,
      key: 'dashboard'
    },
    {
      label: 'Create RFQ',
      path: '/gov/rfqs/create',
      icon: Plus,
      key: 'create-rfq'
    },
    {
      label: 'My RFQs',
      path: '/gov/rfqs',
      icon: FileText,
      key: 'my-rfqs'
    },
    {
      label: 'Review Proposals',
      path: '/gov/proposals',
      icon: Award,
      key: 'review-proposals'
    },
    {
      label: 'Vendors',
      path: '/gov/vendors',
      icon: Users,
      key: 'vendors'
    },
    {
      label: 'Settings',
      path: '/gov/settings',
      icon: Settings,
      key: 'settings'
    }
  ]

  // Government Vendor Navigation Items
  const vendorNavItems = [
    {
      label: 'Dashboard',
      path: '/government',
      icon: Home,
      key: 'dashboard'
    },
    {
      label: 'Available RFQs',
      path: '/gov/rfqs',
      icon: FileText,
      key: 'available-rfqs'
    },
    {
      label: 'My Proposals',
      path: '/gov/proposals',
      icon: Award,
      key: 'my-proposals'
    },
    {
      label: 'Compliance',
      path: '/gov/compliance',
      icon: Shield,
      key: 'compliance'
    },
    {
      label: 'Settings',
      path: '/gov/settings',
      icon: Settings,
      key: 'settings'
    }
  ]

  const navItems = userType === 'AGENCY' ? agencyNavItems : vendorNavItems

  if (!user || (userType !== 'AGENCY' && userType !== 'ENTERPRISE_VENDOR')) {
    return null
  }

  return (
    <nav className={`bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex space-x-8">
          {navItems.map((item) => {
            const IconComponent = item.icon
            const active = isActive(item.path)
            
            return (
              <Link
                key={item.key}
                to={item.path}
                className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors duration-200 ${
                  active
                    ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
                }`}
              >
                <IconComponent className="w-4 h-4 mr-2" />
                {item.label}
              </Link>
            )
          })}
        </div>
      </div>
    </nav>
  )
}